export const nocturn_50 = '#E6EAEB' as const;
export const nocturn_100 = '#B0BDC2' as const;
export const nocturn_200 = '#8A9DA4' as const;
export const nocturn_300 = '#55717B' as const;
export const nocturn_400 = '#345561' as const;
export const nocturn_500 = '#012B3A' as const;
export const nocturn_600 = '#012735' as const;
export const nocturn_700 = '#011F29' as const;
export const nocturn_800 = '#011820' as const;
export const nocturn_900 = '#001218' as const;
export const cedar_50 = '#E6F6F3' as const;
export const cedar_100 = '#B0E3DB' as const;
export const cedar_200 = '#8AD6C9' as const;
export const cedar_300 = '#54C3B1' as const;
export const cedar_400 = '#33B8A1' as const;
export const cedar_500 = '#00A68A' as const;
export const cedar_700 = '#007662' as const;
export const cedar_800 = '#005B4C' as const;
export const cedar_900 = '#00463A' as const;
export const purple_50 = '#F1EEF9' as const;
export const purple_100 = '#D4CBEB' as const;
export const purple_200 = '#BFB1E2' as const;
export const cedar_600 = '#00977E' as const;
export const purple_300 = '#A18ED4' as const;
export const purple_400 = '#8F78CC' as const;
export const purple_500 = '#7356BF' as const;
export const purple_600 = '#694EAE' as const;
export const purple_700 = '#523D88' as const;
export const purple_800 = '#3F2F69' as const;
export const purple_900 = '#302450' as const;
export const lake_50 = '#302450' as const;
export const lake_100 = '#302450' as const;
export const lake_200 = '#302450' as const;
export const lake_300 = '#548596' as const;
export const lake_400 = '#336D82' as const;
export const lake_500 = '#004963' as const;
export const lake_600 = '#00425A' as const;
export const lake_700 = '#003446' as const;
export const lake_800 = '#002836' as const;
export const lake_900 = '#001F2A' as const;
export const blue_50 = '#E9F0FC' as const;
export const blue_100 = '#BAD1F4' as const;
export const blue_200 = '#99BAEF' as const;
export const blue_300 = '#6B9BE8' as const;
export const blue_400 = '#4E87E4' as const;
export const blue_500 = '#2269DD' as const;
export const blue_600 = '#1F60C9' as const;
export const blue_700 = '#184B9D' as const;
export const blue_800 = '#133A7A' as const;
export const blue_900 = '#0E2C5D' as const;
export const green_50 = '#E6F3E9' as const;
export const green_100 = '#B0D9B9' as const;
export const green_200 = '#8AC698' as const;
export const green_300 = '#55AD68' as const;
export const green_400 = '#349D4B' as const;
export const green_500 = '#01841E' as const;
export const green_600 = '#01781B' as const;
export const green_700 = '#015E15' as const;
export const green_800 = '#014911' as const;
export const green_900 = '#00370D' as const;
export const yellow_50 = '#FFF7EB' as const;
export const yellow_100 = '#FFE7C0' as const;
export const yellow_200 = '#FFDCA1' as const;
export const yellow_300 = '#FFD581' as const;
export const yellow_400 = '#FFC25C' as const;
export const yellow_500 = '#FFB333' as const;
export const yellow_600 = '#E8A32E' as const;
export const yellow_700 = '#B57F24' as const;
export const yellow_800 = '#8C621C' as const;
export const yellow_900 = '#6B4B15' as const;
export const red_50 = '#FBE6E6' as const;
export const red_100 = '#F1B3B1' as const;
export const red_200 = '#EB8E8B' as const;
export const red_300 = '#E25A56' as const;
export const red_400 = '#DC3A35' as const;
export const red_500 = '#D30903' as const;
export const red_600 = '#C00803' as const;
export const red_700 = '#960602' as const;
export const red_800 = '#740502' as const;
export const red_900 = '#590401' as const;
export const dark_grey_50 = '#EBEBEB' as const;
export const dark_grey_100 = '#C0C0C0' as const;
export const dark_grey_200 = '#A1A1A1' as const;
export const dark_grey_300 = '#767676' as const;
export const dark_grey_400 = '#5C5C5C' as const;
export const dark_grey_500 = '#333333' as const;
export const dark_grey_600 = '#2E2E2E' as const;
export const dark_grey_700 = '#242424' as const;
export const dark_grey_800 = '#1C1C1C' as const;
export const dark_grey_900 = '#151515' as const;
export const grey_50 = '#FDFDFD' as const;
export const grey_100 = '#F7F8F9' as const;
export const grey_200 = '#F4F5F6' as const;
export const grey_300 = '#EEF1F2' as const;
export const grey_400 = '#EBEEEF' as const;
export const grey_500 = '#E6EAEB' as const;
export const grey_600 = '#D1D5D6' as const;
export const grey_700 = '#8A8E8F' as const;
export const grey_800 = '#7F8181' as const;
export const grey_900 = '#616263' as const;
